// The origin every API client, document link and profile image URL is resolved against.
//
// On a deployed host this is simply the origin serving the SPA. On localhost it must name the
// backend explicitly, because the dev SPA and the dev API are served from different ports.
//
// The localhost value comes from the worktree's runtime slot, injected at build time by
// vite.config.ts. It was previously hard-coded to :7202, which meant a second worktree's SPA -
// served on its own port, against its own database - still sent every API call to the FIRST
// worktree's server. Nothing on screen showed it: the app worked, against the wrong data.
//
// The literal below is the pre-slot default and is used whenever no slot is claimed, which keeps a
// fresh clone and CI behaving exactly as before.
const viteEnv = (
  import.meta as unknown as { env: { VITE_API_ORIGIN?: string } }
).env;

export const defaultDomain = window.location.hostname.includes('localhost')
  ? (viteEnv.VITE_API_ORIGIN ?? 'https://localhost:7202')
  : window.location.origin;
